import styled from 'styled-components';

export interface ScRegPaymentsProps {
  marginTop?: number;
}

export const ScRegPayments = styled.div<ScRegPaymentsProps>`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : 0)};

  & > img {
    height: 20px;
    width: auto;
  }
`;
